import { HStack, Text, VStack } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import {
  getCreditFacilityListQueryKey,
  useCreditFacilityDelete,
} from "gen/endpoints/credit-facility/credit-facility";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CreditFacilityDraftPage: React.FC = () => {
  const { fundFamilyId, creditFacilityId } = useRequiredStringParams();
  const { t } = useTranslation(["creditFacility", "common"]);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutateAsync: deleteCreditFacility } = useCreditFacilityDelete();
  const onContinue = () =>
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .creditFacilities({})
        .creditFacility({ creditFacilityId })
        .setup({}).$,
    );

  return (
    <PageContent isFullHeight={true}>
      <PageBody>
        <VStack
          flex={1}
          alignItems="center"
          justifyContent="center"
          bg="white"
          borderColor="gray.200"
          borderWidth="1px"
          borderRadius="8px"
          my="24px"
          py="32px"
          spacing="24px"
        >
          <Text textStyle="h2">{t("creditFacility:draft.title")}</Text>
          <HStack>
            <Button
              colorScheme="secondary"
              onClick={async () => {
                await deleteCreditFacility({ fundFamilyId, creditFacilityId });
                await queryClient.invalidateQueries({
                  queryKey: getCreditFacilityListQueryKey(fundFamilyId),
                });
                navigate(
                  rootRoute({})
                    .fundFamilies({})
                    .fundFamily({ fundFamilyId })
                    .setup({})
                    .creditFacilities({}).$,
                );
              }}
            >
              {t("common:discardDraft")}
            </Button>
            <Button onClick={onContinue}>
              {t("creditFacility:draft.continueCta")}
            </Button>
          </HStack>
        </VStack>
      </PageBody>
    </PageContent>
  );
};
